import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import HomeView from './views/home-view/home-view';
import ThankYouQ from './views/thank-you-q/thank-you-q';
import JoinTheQuantityView from './views/join-the-quantity/join-the-quantity';

import './App.css';

function App() {
  return (
    <div className="app">
      <BrowserRouter>
      <Switch>
        <Route exact path="/" component={HomeView} />
        <Route path="/thank-you-q" component={ThankYouQ} />
        <Route path="/join-the-quantity" component={JoinTheQuantityView} />
      </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;